import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TelegramService} from '../../telegram.service';
import {SenderService} from '../../../../services/sender.service';
import {InterfaceService} from '../../../../services/interface.service';
import {NzUploadChangeParam} from 'ng-zorro-antd/upload';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-sign-telegram-tdata',
  templateUrl: './sign-telegram-tdata.component.html',
  styleUrls: ['./sign-telegram-tdata.component.scss']
})
export class SignTelegramTdataComponent {
  fileList: any = [];
  public environment = environment;
  @Input() telegramService: TelegramService;
  public lastError: any;
  @Output() resetService = new EventEmitter<void>();
  _isLoading = false;
  get tdataApiUrl(): string {
   return `${environment.tdata}/api/sender/tdata`;
  }

  get tdataHeaders(): any {
    // TODO передавать токен прошлого аккаунта
    return {
      authorization: 'Token ' +  this.telegramService.token,
      tokens: this.senderService.authTokens.join(','),
      partner: this.senderService.partnerId
    };
  }

  constructor(
    public cd: ChangeDetectorRef,
    public interfaceService: InterfaceService,
    public senderService: SenderService,
    ) { }

  handleChange(info: NzUploadChangeParam): void {
    this.lastError = '';
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {

      this.telegramService.setAuth();
      this.telegramService.loadProfile();
      if (info?.file?.response?.account?.id) {
        this.senderService.setAccount(info?.file?.response.account, this.telegramService);
      }
      this.resetService.next();
      // this.goPage();
    } else if (info.file.status === 'error') {
      this.resetService.next();
      console.log('Error auth tdata', info);
      if (info?.file?.error?.error?.detail?.error_id === 'USER_DEACTIVATED_BAN') {
        info.file.error.error.detail.message += ' Скорее всего, Ваш tdata плохого качества, купите у другого продавца.';
      }
      this.lastError = info.file?.error || 'Неизвестная ошибка';
      this.isLoading = false;
    }
  }
  get isLoading() {
    return this._isLoading;
  }

  set isLoading(val) {
    this._isLoading = val;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 100);
  }
}
